import { PureComponent } from 'react';
import { Field, Form, formValues, reduxForm } from 'redux-form/immutable';

import { isNullable } from '@ipfabric/utils';
import { Button } from 'components/Button/Button';
import RadioField from 'components/RadioField';
import LTEBox from 'containers/LTEBox';
import LeaveDialogue from 'containers/LeaveDialogue';
import ScheduleField from 'containers/ScheduleField';
import PropTypes from 'prop-types';
import { handleSubmitFail } from 'utils/formValidation';
import handleEvent from 'utils/handleEvent';
import formName from './formName';

// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: legacy code
const validate = (values) => {
  const errors = {};
  const trigger = values.get('trigger');
  const triggerTime = values.get('triggerTime');
  const cron = values.get('cron');
  if (!trigger) {
    errors.trigger = 'triggerRequired';
  }
  if (trigger === 'timer') {
    if (!triggerTime) {
      errors.triggerTime = 'triggerTimeRequired';
      // biome-ignore lint/suspicious/noGlobalIsNan: cannot be safely replaced in untyped code; replace with legacy code refactoring later.
    } else if (isNaN(triggerTime)) {
      errors.triggerTime = 'triggerNumber';
    }
  }
  if (trigger === 'schedule') {
    if (!cron) {
      errors.cron = 'cronRequired';
    } else {
      const split = cron.expression.split(' ');
      const first = split[0];
      if (!split.length === 5) {
        errors.cron = 'invalidCron';
      } else if (first === '*' || first === '' || isNullable(first)) {
        errors.cron = 'minutes';
      }
    }
  }
  return errors;
};

@reduxForm({
  form: formName,
  enableReinitialize: true,
  pure: false,
  onSubmitFail: handleSubmitFail('btn-save'),
  validate,
})
@formValues('trigger')
export default class Syslog extends PureComponent {
  static propTypes = {
    componentAsPage: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    saveChangeOnLeave: PropTypes.bool.isRequired,
    leaveDialogueMessages: PropTypes.object,
    msg: PropTypes.object.isRequired,
    msgScheduleField: PropTypes.object.isRequired,
    onSetReturnUrl: PropTypes.func.isRequired,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    trigger: PropTypes.string,
    valid: PropTypes.bool,
  };

  handleLeaveDialogueSave = handleEvent((returnUrl) => {
    const { handleSubmit, onSetReturnUrl } = this.props;
    onSetReturnUrl(returnUrl);
    handleSubmit();
  });

  render() {
    const {
      componentAsPage,
      handleSubmit,
      leaveDialogueMessages,
      msg,
      msgScheduleField,
      pristine,
      saveChangeOnLeave,
      submitting,
      trigger,
      valid,
    } = this.props;
    return (
      <div>
        {msg.help}
        <LTEBox
          bodyComponent={
            <div>
              <LeaveDialogue
                saveChangeOnLeave={saveChangeOnLeave}
                isPristine={pristine}
                onSave={this.handleLeaveDialogueSave}
                msg={leaveDialogueMessages}
                isValid={valid}
                saving={submitting}
              />
              <Form className='form-inline-s' onSubmit={handleSubmit}>
                <fieldset disabled={submitting}>
                  <div className='form-group'>
                    <div className='input-group'>
                      <label htmlFor='advancedSyslogSyslogtrigger'>
                        <Field
                          component={RadioField}
                          id='advancedSyslogSyslogtrigger'
                          msg={msg}
                          name='trigger'
                          type='radio'
                          value='syslogtrigger'
                        />
                        <span className='ml-2 font-normal'>
                          {msg.optionSyslogtrigger}
                        </span>
                      </label>
                    </div>
                    <div className='input-group'>
                      <label htmlFor='advancedSyslogSchedule'>
                        <Field
                          component={RadioField}
                          id='advancedSyslogSchedule'
                          msg={msg}
                          name='trigger'
                          type='radio'
                          value='schedule'
                          enableValidation
                        />
                        <span className='ml-2 font-normal'>
                          {msg.optionSchedule}
                        </span>
                      </label>
                    </div>
                    {trigger === 'schedule' && (
                      <div className='input-group'>
                        <Field
                          className='form-control'
                          component={ScheduleField}
                          id='advancedSnapshotsInterval'
                          msg={msgScheduleField}
                          name='cron'
                          type='text'
                        />
                      </div>
                    )}
                  </div>
                  {componentAsPage ? (
                    <Button
                      disabled={submitting}
                      variant='primary'
                      id='btn-save'
                    >
                      {msg.btnSave}
                    </Button>
                  ) : null}
                </fieldset>
              </Form>
            </div>
          }
          className='box box-primary'
          title={msg.boxTitle}
        />
      </div>
    );
  }
}
